"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const experimentTypes_1 = require("../types/experimentTypes");
exports.default = (experiment, config) => {
    const experimentGoals = Object.values(experimentTypes_1.ExperimentGoal);
    if (!experimentGoals.includes(experiment.goal)) {
        throw new Error(`${experiment.name} goal not recognised. Choose one of: ${experimentGoals}`);
    }
    if ([experimentTypes_1.ExperimentGoal.ConversionRate, experimentTypes_1.ExperimentGoal.AverageOrderValue, experimentTypes_1.ExperimentGoal.Profitability].includes(experiment.goal)) {
        // TODO: Validate and throw - e.g. expiry is present
        return true;
    }
    if (experiment.goal === experimentTypes_1.ExperimentGoal.Rollout) {
        // TODO: Validate and throw - e.g. expiry is present
        return true;
    }
    return false;
};
//# sourceMappingURL=getIsExperimentValid.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/utils/getIsExperimentValid.js
// module id = gPE1
// module chunks = 69